
import {
  Box,
  Typography,
  Paper,
  Skeleton,
  Divider,
} from "@mui/material";

const ScopesSkeleton = () => {
  return (
    <Box p={3}>
      {/* Tabs */}
      <Box display="flex" gap={3} mb={2}>
        {["SCOPES", "SEARCH TERMS", "AI RECOMMENDATIONS"].map((_, idx) => (
          <Skeleton
            key={idx}
            variant="rectangular"
            width={140}
            height={30}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Box>

      {/* Manage Section */}
      <Typography variant="h6" gutterBottom>
        <Skeleton width={120} />
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
        {/* Scope rows */}
        {[1, 2].map((row) => (
          <Box
            key={row}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
          >
            {/* Scope name */}
            <Skeleton width={150} height={30} />

            {/* Campaign chips */}
            <Box display="flex" gap={1} flexWrap="wrap" maxWidth="70%">
              {[...Array(4)].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  width={120}
                  height={28}
                  sx={{ borderRadius: "16px" }}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Paper>

      {/* Anomalies */}
      <Typography variant="h6" gutterBottom>
        <Skeleton width={150} />
      </Typography>

      <Paper variant="outlined" sx={{ p: 2 }}>
        {[1, 2, 3].map((item) => (
          <Box key={item}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              py={1}
            >
              <Skeleton width={250} height={25} />
              <Skeleton width={200} height={25} />
            </Box>
            {item !== 3 && <Divider />}
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default ScopesSkeleton;
